import { gql } from "@apollo/client";

const STUDENT_RESET_PASSWORD = gql`
  mutation ResetPassword($email: String!, $redirectUrl: String!) {
    studentSendPasswordResetWithToken(
      email: $email
      redirectUrl: $redirectUrl
    ) {
      message
    }
  }
`;

export default STUDENT_RESET_PASSWORD;
